import React, { useState } from 'react';
import InputWithButton from '@monofront/design-system/components/Form/InputWithButton';
import { useRouter } from 'next/router';
import logger from '@utils/logger';
import { toast } from 'react-toastify';
import { useTranslations } from 'next-intl';
import { EMAIL_REGEX } from '@monofront/business/constants';
import { fetchSignInMethodsForEmail, getAuth } from '@firebase/auth';

interface IEmailFieldProps {
  ctaLabel: string;
}

const EmailField: React.FC<IEmailFieldProps> = ({ ctaLabel }) => {
  const router = useRouter();
  const tErrors = useTranslations('Errors');
  const tAccount = useTranslations('Account');
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async ({ email }: { [key: string]: string }) => {
    try {
      setIsLoading(true);
      const authProviders = await fetchSignInMethodsForEmail(getAuth(), email);

      if (authProviders && authProviders.length > 0) {
        router.push(
          { pathname: '/account/login', query: { email } },
          '/account/login',
        );
      } else {
        router.push(
          { pathname: '/account/register/flow', query: { email } },
          '/account/register/flow',
        );
      }
    } catch (e) {
      setIsLoading(false);
      logger.error(`Failed to check if this email exists in Firebase: ${e}`);
      toast(tErrors('anErrorOccuredTryAgain'), {
        progressClassName: 'toast-error',
      });
    }
  };

  return (
    <InputWithButton
      inputProps={{
        placeholder: tAccount('yourEmail'),
        name: 'email',
        type: 'email',
      }}
      registerOptions={{
        required: {
          value: true,
          message: tAccount('useValidEmail'),
        },
        pattern: {
          value: EMAIL_REGEX,
          message: tAccount('useValidEmail'),
        },
      }}
      buttonProps={{
        isLoading,
        canBeDisabled: false,
      }}
      handleSubmit={onSubmit}
    >
      {ctaLabel}
    </InputWithButton>
  );
};

export default EmailField;
